const typography = {
  body1: {
    fontSize: '1rem',
    letterSpacing: '0.00938rem',
    lineHeight: 1.125,
  },
  body2: {
    fontSize: '1rem',
    letterSpacing: '0.00938rem',
    lineHeight: 1.125,
  },
  button: {
    fontSize: '0.875rem',
  },
  caption: {
    fontSize: '0.6875rem',
    letterSpacing: '0.33px',
  },
  fontFamily: 'red Hat Display Regular',
  h1: {
    fontSize: '2.25rem',
    fontWeight: 500,
  },
  h2: {
    fontSize: '1.875rem',
    fontWeight: 500,
  },
  h3: {
    fontSize: '1.5rem',
    fontWeight: 500,
  },
  h4: {
    fontSize: '1.25rem',
    fontWeight: 500,
  },
  h5: {
    fontSize: '1rem',
    fontWeight: 500,
  },
  h6: {
    fontSize: '0.875rem',
    fontWeight: 500,
  },
  overline: {
    fontSize: '0.6875rem',
    fontWeight: 500,
    letterSpacing: '0.33px',
  },
  subtitle1: {
    fontSize: '1rem',
  },
  subtitle2: {
    fontSize: '0.875rem',
    fontWeight: 400,
  },
};

export default typography;
